const LOGO_URL = "/logo-2513.png";

export const Logo = ({ className = "h-10 w-auto", alt = "LAB 2513" }) => (
  <img src={LOGO_URL} alt={alt} className={className} draggable={false} />
);
